var SubResource = function() {
  var self = this;

  self.getPackages = function(options) {
    request.get($.extend(true, {
      url: '/api/subscriptions'
    }, options));
  };
};

window.subResource = new SubResource();